var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselGifts = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "5fe60w8d9a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#5fe60w8d9a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC8D",
    d: "M30.277 34.954v19.044l20.578-11.782-.01-19.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFBD58",
    d: "M30.277 34.96v-.63l20.56-11.715v.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC8D",
    d: "M52 17.28v4.686L30.31 34.35v-4.647"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C75F",
    d: "M30.277 34.956V54L10.08 42.218l.01-19.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CB8F2B",
    d: "m30.285 36.022.014-1.709-20.22-11.702-.016 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C75F",
    d: "M30.313 29.616v4.734L9 22.195l.145-4.487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE4AE",
    d: "M30.323 29.753 9.163 17.764 29.595 6 51.95 17.339"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DBBC7",
    d: "m17.775 22.615 2.904 1.747 21.271-12.08-3.476-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DBBC7",
    d: "m17.58 22.678-.31 23.727 3.207 1.85.341-23.915-3.239-1.82M42.542 22.744l-3.176 1.908L18.412 12.4l3.159-1.792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.552 17.592c-.237.31-.48.598-.727.87a16.436 16.436 0 0 0 3.064-2.365c.123-.122 1.315-1.31 2.337-3.123 0 0 .778-1.383.517-2.308-.094-.334-.305-.55-.305-.55a1.232 1.232 0 0 0-.67-.34c-.036-.005-.671-.106-1.113.322-.107.104-1.225 5.049-3.103 7.492v.002z",
    fill: "#3894A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.55 9.75 2.931 1.806c.645-.824 1.312-1.313 1.698-1.468.263-.105.55-.219.896-.16.086.015.137.032.145.017.043-.08-1.082-.728-1.945-1.17-.421-.217-.798-.393-1.321-.455-.19-.024-.347-.043-.561-.018-.853.097-1.51.757-1.81 1.349l-.027.056",
    fill: "#C5DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.507 11.423a17.02 17.02 0 0 0-1.577 3.099 17.036 17.036 0 0 0-.97 3.77c-.03-.063-.073-.16-.122-.274-.807-1.886-.888-3.484-.945-4.877 0 0-.06-1.49.224-2.467.143-.487.386-.892.386-.892.016-.025.028-.046.037-.058",
    fill: "#9FCCD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.84 18.18a7.552 7.552 0 0 0-.357-1.992 8.156 8.156 0 0 0-.558-1.32c-.332-.63-.534-1.015-.955-1.435a4.133 4.133 0 0 0-1.023-.747 4.073 4.073 0 0 0-3.907.172l2.43 1.861",
    fill: "#C5DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.004 12.893c-.24.236-.535.59-.772 1.072a4.036 4.036 0 0 0-.395 1.431c-.043.413-.082.798.057 1.252.15.482.416.77.769 1.147.74.796 1.476 1.101 2.18 1.393.412.173.506.17.567.124.27-.209-.38-1.147-.404-2.673-.002-.16-.008-.314.015-.502.077-.619.355-1.085.557-1.363l-2.53-1.931",
    fill: "#9FCCD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.832 18.184a5.537 5.537 0 0 0-1.482-2.613c-.682-.668-1.078-.921-1.433-1.008-.214-.053-.727-.178-1.227.096-.38.21-.553.544-.614.68-.23.518-.074.99-.035 1.1l2.133 1.221 2.658.524z",
    fill: "#8DBBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.734 18.244c-.38.393-2.278 2.419-2.313 5.034-.02 1.47.55 2.966.602 3.096.196.503.408.905.57 1.187l3.043-1.439a7.772 7.772 0 0 1-1.702-2.811c-.811-2.387-.182-4.467.077-5.189",
    fill: "#9FCCD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.272 15.164c-.159.142-.37.362-.547.68-.25.454-.292.86-.32 1.156-.037.416-.078.861.16 1.349.068.143.245.495.639.746.38.242.754.258 1.115.267.31.01.702-.07 1.475-.23.968-.199 1.356-.317 1.784-.536.143-.073.26-.14.339-.191a8.444 8.444 0 0 1-2.669-.228c-.098-.026-.907-.24-1.415-.709a1.657 1.657 0 0 1-.427-.582 1.538 1.538 0 0 1-.11-.395",
    fill: "#3894A3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9FCCD7",
    d: "m29.852 18.43 13.39-2.747.104 2.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFBD58",
    d: "m30.299 36.022-.01-1.71 20.533-11.697.015 2.012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8DBBC7",
    d: "m42.552 22.9.316 23.866-3.21 1.862-.34-24.029 3.236-1.859"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselGifts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-gifts.e7855c491cc1317fc83976c352a93968.svg";